export enum InvoiceStatus {
  Draft = "Draft",
  Invoiced = "Invoiced",
  Paid = "Paid",
  Voided = "Voided",
}
